import { createRoot } from "react-dom/client";
import App from "./App";
import { CoralogixRum } from "@coralogix/browser";

/**
 * Should only be executed once in the lifecycle of the application
 * quick trick relying on webpack injecting values to determine if we're running in a local dev environment,
 * or a build
 *
 * process.env.NODE_ENV gets filled by webpack depending on the mode the build is transpiled with
 * https://webpack.js.org/configuration/mode
 */

if (process.env.NODE_ENV === "development")
  __symphony_env__.REACT_APP_VERSION = `DEV_${__webpack_env__.package_version}`;

if (__symphony_env__.REACT_CORALOGIX_KEY)
  CoralogixRum.init({
    public_key: __symphony_env__.REACT_CORALOGIX_KEY,
    application: "rum_cx",
    version: __symphony_env__.REACT_APP_VERSION ?? "",
    coralogixDomain: "US2",
  });
const container = document.getElementById("root");
const root = createRoot(container as HTMLElement);
root.render(<App />);
